function parseNumber(raw: string | undefined, name: string, fallback: number): number {
  const n = Number(raw)
  if (!raw || isNaN(n)) {
    console.error(`[region] Invalid or missing ${name}, using fallback: ${fallback}`)
    return fallback
  }
  return n
}

function parseString(raw: string | undefined, name: string, fallback: string): string {
  if (!raw) {
    console.error(`[region] Missing ${name}, using fallback: ${fallback}`)
    return fallback
  }
  return raw
}

const locale = parseString(import.meta.env.VITE_REGION_LOCALE, 'VITE_REGION_LOCALE', 'en-AU')
const currency = parseString(import.meta.env.VITE_REGION_CURRENCY, 'VITE_REGION_CURRENCY', 'AUD')
const countryCode = parseString(
  import.meta.env.VITE_REGION_COUNTRY_CODE,
  'VITE_REGION_COUNTRY_CODE',
  'AUS'
)

export const regionConfig = {
  locale,
  currency,
  countryCode, // ISO 3166-1 alpha-3 — used in user profile forms
  mapBounds: {
    sw: {
      lat: parseNumber(import.meta.env.VITE_REGION_MAP_SW_LAT, 'VITE_REGION_MAP_SW_LAT', -44.0),
      lng: parseNumber(import.meta.env.VITE_REGION_MAP_SW_LNG, 'VITE_REGION_MAP_SW_LNG', 96.0)
    },
    ne: {
      lat: parseNumber(import.meta.env.VITE_REGION_MAP_NE_LAT, 'VITE_REGION_MAP_NE_LAT', -9.0),
      lng: parseNumber(import.meta.env.VITE_REGION_MAP_NE_LNG, 'VITE_REGION_MAP_NE_LNG', 168.0)
    }
  }
} as const
